// import anime from 'animejs/lib/anime.es.js';





// import Agegate from './agegate';
// import Scroller from './scroller';
// import Drawer from './drawer';
// import Listeners from './listeners';
// import Slider from './sliders';
// import Accordion from './accordion';
// import Lightbox from './lightbox';

import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles
AOS.init({ duration: 500 });


import { getPaulistaArea, getIguatemiJKArea } from './deliveryarea';

const paulistaKML = getPaulistaArea();
const iguatemijkKML = getIguatemiJKArea();
const scrollElement = window.document.scrollingElement || window.document.body || window.document.documentElement;

// new Agegate();
// new Scroller();
// new Drawer();
// new Listeners();
// new Slider();
// new Accordion();
// new Lightbox();
// new Challenge();

// anime({
// 		  targets: 'body',
// 		  opacity: {
// 			  value: 1,
// 			  duration: 1000,
// 			  delay: 100,
// 		  }
// 		});

import 'jsmask';
import Swiper, { Navigation, Controller, Autoplay, EffectFade } from 'swiper';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/effect-fade';

import { jarallax } from "jarallax";

jarallax(document.querySelectorAll('.jarallax'), {
    //speed: 0.2,
});

import { gsap } from "gsap";
import { scrollTrigger } from "gsap/dist/scrollTrigger";

const swiper_hero = new Swiper('.swiper-hero', {
    slidesPerView: 1,
    modules: [Autoplay, EffectFade, Controller],
    loop: true,
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },

    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    },

});

// init Swiper:
const swiper = new Swiper('.swiper-general', {
    slidesPerView: 1,
    loop: true,
    modules: [Navigation],
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});

// swiper.slideNext();
var $ = jQuery;

$(document).ready(function() {
    $('#hero').css('opacity', '1');
});

window.addEventListener('load', (e) => {
    if (location.hash) {
        updateScroll(location.hash);
    }

}, false);

window.addEventListener('hashchange', (e) => {
    if (location.hash) {
        updateScroll(location.hash);
    }
}, false);

$('ul.home li a').on('click', function(e) {
    if ($(this).hasClass('instagram')) {
        return;
    }
    if ($('body').hasClass('home')) {
        e.preventDefault();
        var href = $(this).attr('href');
        var hash = href.substr(href.indexOf("#"));
        updateScroll(hash);
    } else {
        return;
    }
});
$('a.btn.anchor').on('click', function(e) {
    if ($('body').hasClass('home')) {
        e.preventDefault();
        var href = $(this).attr('href');
        var hash = href.substr(href.indexOf("#"));
        updateScroll(hash);
    } else {
        return;
    }
});

function updateScroll(section) {
    $('.menu-close.close-btn').click();
    var headeH = $('#masthead').height();
    var section = section;
    section = section.substr(section.indexOf("#"));
    var goal = $(section).offset().top - headeH * 1.05;
    var atual = $(scrollElement).scrollTop();
    var speed = 500;
    if (atual == 0) {
        atual = headeH;
    }
    if (atual <= goal) {
        //descendo
        speed = goal - atual;
        speed = speed * 0.75;
    } else {
        //subindo
        speed = atual - goal;
        speed = speed * 0.75;

    }
    setTimeout(function() {
        speed = Math.round(speed);
        console.log(speed);
        anime({
            targets: scrollElement,
            scrollTop: goal,
            duration: speed,
            easing: 'easeInOutQuad'
        });
    }, 100);
}


// setTimeout(function() {
//     //  $('.site-branding img').addClass('hero');
// }, 5000);

if ($('body').hasClass('home')) {
    $('.site-header').addClass('hero');
    var wheight = $(window).height();
    wheight = wheight / 4;
    $(window).on('scroll', function() {
        location.hash = "";
        if ($(window).scrollTop() > wheight) {
            $('.site-header').removeClass('hero');
        } else {
            $('.site-header').addClass('hero');
        }
    })
}

(function($) {

    if (location.hash) {
        updateScroll(location.hash);
    }
    if ($('#instagram .swiper-insta').css('display') == 'block') {
        var html = ' ';
        $('.sbi_photo').each(function() {
            html += '<div class="swiper-slide">';
            html += '<a target="_blank" href="' + $(this).attr('href') + '">';
            html += $(this).html();
            html += '</a></div>';
        })
        $('#instagram .swiper-insta .swiper-wrapper').html(html);
        $('#sb_instagram').remove();

        const swiperinsta = new Swiper('#instagram .swiper-insta', {
            slidesPerView: 'auto',
            loop: true,
            spaceBetween: 15,
            centeredSlides: true,
        });

    }
    $('.btn-del').on('click', function(e) {
        e.preventDefault();
        openDeliveryModal();
    });


    function openDeliveryModal() {
        $('.delivery-lightbox').addClass('open');
        $(".zip-code").on('input', function() {
            jsmask(this, "00000-000");
            if (this.value.length == 5) {
                this.value = this.value + '-';
            }
        });
        $(".zip-code").on('keypress', function(e) {
            if (e.keyCode === 13) {
                e.preventDefault(); // Ensure it is only this code that runs
                $('#search-zip').trigger('click');
            }
        });

        $('#search-zip').on('click', function(e) {
            e.preventDefault();
            var clientZip = $(".zip-code").val();
            if (clientZip.length == 9) {
                getZip(clientZip);
            } else {
                $('.delivery-lightbox p.response').html('Por favor, digite um CEP válido.');
            }
        });
        $('.delivery-lightbox').on('click', function(e) {
            if ($(e.target).hasClass('delivery-lightbox')) {
                closeDeliveryModal();
            }
        });
        $('.delivery-lightbox .btn-close').on('click', function(e) {
            closeDeliveryModal();
        });
    }

    function closeDeliveryModal() {
        $('.delivery-lightbox').removeClass('open');
        $('.delivery-lightbox').removeClass('ifood');
        $('.delivery-lightbox').removeClass('paulista');
        $('.delivery-lightbox').removeClass('iguatemijk');
    }

    function getZip(clientZip) {
        var getJSON = function(url, callback) {

            var xhr = new XMLHttpRequest();
            xhr.open('GET', url, true);
            xhr.responseType = 'json';

            xhr.onload = function() {

                var status = xhr.status;

                if (status == 200) {
                    callback(null, xhr.response);
                } else {
                    callback(status);
                }
            };

            xhr.send();
        };

        //var url = 'https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyCkRyJuyEo537LVlLJn6q-Uxoyx9hu_ST4&components=postal_code:' + clientZip;
        var url = 'https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyAhYRacbmoVsPXRcsdFrdNgXvG4l29k2X0&components=postal_code:' + clientZip;

        getJSON(url, function(err, data) {
            console.log(data);
            if (err != null) {
                console.error(err);
            } else {
                if (data.results.length > 0) {
                    if (data.results['0'].address_components['3']['long_name'] != 'São Paulo') {
                        $('.delivery-lightbox p.response').html('Infelizmente atuamos apenas na cidade de São Paulo.');
                    } else {
                        checkAddress(data.results['0'].geometry.location.lat, data.results['0'].geometry.location.lng);

                    }

                } else {
                    $('.delivery-lightbox p.response').html('Por favor, digite um cep válido.');
                }
            }
        });
    }

    function checkAddress(clat, clng) {

        const clientZip = {
            lat: parseFloat(clat),
            lng: parseFloat(clng)
        };

        const paulistaArea = new google.maps.Polygon({
            paths: paulistaKML
        });
        const paulista = google.maps.geometry.poly.containsLocation(clientZip, paulistaArea);
        console.log(paulista);

        if (paulista) {
            $('.delivery-lightbox').addClass('paulista');
            return;
        }

        const iguatemijkArea = new google.maps.Polygon({
            paths: iguatemijkKML
        });
        const iguatemijk = google.maps.geometry.poly.containsLocation(clientZip, iguatemijkArea);
        console.log(iguatemijk);
        if (iguatemijk) {
            $('.delivery-lightbox').addClass('iguatemijk');
            return;
        }

        $('.delivery-lightbox').addClass('ifood');
        console.log('ifood');


    }

})(jQuery);